export default "__VITE_ASSET__94ea471a__"